import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgFiltersIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="filters_svg__nc-icon-wrapper">
      <path d="M13 32V3a1 1 0 0 0-2 0v29a1 1 0 0 0 2 0ZM13 61V49h7a1 1 0 0 0 1-1V38a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7v12a1 1 0 0 0 2 0ZM51 3v29a1 1 0 0 0 2 0V3a1 1 0 0 0-2 0ZM43 38v10a1 1 0 0 0 1 1h7v12a1 1 0 0 0 2 0V49h7a1 1 0 0 0 1-1V38a1 1 0 0 0-1-1H44a1 1 0 0 0-1 1Z" />
      <path
        data-color="color-2"
        d="M31 3v7a1 1 0 0 0 2 0V3a1 1 0 0 0-2 0ZM33 61V27h7a1 1 0 0 0 1-1V16a1 1 0 0 0-1-1H24a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7v34a1 1 0 0 0 2 0Z"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgFiltersStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgFiltersIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const FiltersIcon: any = SvgFiltersStyle;
export default FiltersIcon;
